import { collection, addDoc, getDocs, query } from 'firebase/firestore';
import { db } from '../firebase/config';

export const DEFAULT_CATEGORIES = [
  {
    id: 'science',
    name: 'Sciences',
    emoji: '⚛️',
    color: 'from-blue-500 to-cyan-500',
    description: 'Explore the natural world and scientific principles',
    isActive: true,
    order: 0,
    topics: [
      { name: 'Physics', description: 'Study of matter, energy, and forces', isActive: true, order: 0 },
      { name: 'Chemistry', description: 'Science of substances and their interactions', isActive: true, order: 1 },
      { name: 'Biology', description: 'Study of living organisms', isActive: true, order: 2 },
      { name: 'Astronomy', description: 'Study of celestial objects and space', isActive: true, order: 3 },
      { name: 'Environmental Science', description: 'Study of environment and sustainability', isActive: true, order: 4 }
    ]
  },
  {
    id: 'arts',
    name: 'Arts & Design',
    emoji: '🎨',
    color: 'from-pink-500 to-rose-500',
    description: 'Express yourself through creative arts',
    isActive: true,
    order: 1,
    topics: [
      { name: 'Drawing', description: 'Visual art with pencils, pens, and more', isActive: true, order: 0 },
      { name: 'Music Theory', description: 'Understanding the language of music', isActive: true, order: 1 },
      { name: 'Photography', description: 'Capturing moments through the lens', isActive: true, order: 2 },
      { name: 'Film Making', description: 'Creating stories through video', isActive: true, order: 3 },
      { name: 'Animation', description: 'Bringing drawings and models to life', isActive: true, order: 4 }
    ]
  },
  {
    id: 'tech',
    name: 'Technology',
    emoji: '💻',
    color: 'from-purple-500 to-indigo-500',
    description: 'Build the future with technology',
    isActive: true,
    order: 2,
    topics: [
      { name: 'Programming', description: 'Write code to create software', isActive: true, order: 0 },
      { name: 'AI & ML', description: 'Artificial Intelligence and Machine Learning', isActive: true, order: 1 },
      { name: 'Robotics', description: 'Design and build intelligent machines', isActive: true, order: 2 },
      { name: 'Game Development', description: 'Create interactive games', isActive: true, order: 3 },
      { name: 'Web Design', description: 'Design beautiful websites', isActive: true, order: 4 }
    ]
  },
  {
    id: 'humanities',
    name: 'Humanities',
    emoji: '🌍',
    color: 'from-orange-500 to-amber-500',
    description: 'Understand human culture and society',
    isActive: true,
    order: 3,
    topics: [
      { name: 'History', description: 'Learn from the past', isActive: true, order: 0 },
      { name: 'Philosophy', description: 'Explore fundamental questions', isActive: true, order: 1 },
      { name: 'Psychology', description: 'Study of mind and behavior', isActive: true, order: 2 },
      { name: 'Literature', description: 'Explore great works of writing', isActive: true, order: 3 },
      { name: 'Languages', description: 'Learn to communicate globally', isActive: true, order: 4 }
    ]
  },
  {
    id: 'life',
    name: 'Life Skills',
    emoji: '❤️',
    color: 'from-green-500 to-emerald-500',
    description: 'Essential skills for everyday life',
    isActive: true,
    order: 4,
    topics: [
      { name: 'Communication', description: 'Express yourself effectively', isActive: true, order: 0 },
      { name: 'Leadership', description: 'Inspire and guide others', isActive: true, order: 1 },
      { name: 'Financial Literacy', description: 'Manage money wisely', isActive: true, order: 2 },
      { name: 'Health & Wellness', description: 'Take care of your body and mind', isActive: true, order: 3 },
      { name: 'Entrepreneurship', description: 'Start and grow your own business', isActive: true, order: 4 }
    ]
  },
  {
    id: 'creative',
    name: 'Creative',
    emoji: '💡',
    color: 'from-yellow-500 to-orange-500',
    description: 'Unleash your creative potential',
    isActive: true,
    order: 5,
    topics: [
      { name: 'Writing', description: 'Tell stories with words', isActive: true, order: 0 },
      { name: 'Music Composition', description: 'Create your own music', isActive: true, order: 1 },
      { name: '3D Modeling', description: 'Design in three dimensions', isActive: true, order: 2 },
      { name: 'Cooking', description: 'Master the culinary arts', isActive: true, order: 3 },
      { name: 'Crafts', description: 'Make things with your hands', isActive: true, order: 4 }
    ]
  }
];

export const seedDefaultCategories = async () => {
  try {
    // Check if categories already exist
    const categoriesRef = collection(db, 'unschooling_categories');
    const existingCategories = await getDocs(query(categoriesRef));
    
    if (existingCategories.size > 0) {
      return {
        success: false,
        message: 'Categories already exist. Clear them first if you want to reseed.',
        count: existingCategories.size
      };
    }

    // Add all default categories
    let addedCount = 0;
    for (const category of DEFAULT_CATEGORIES) {
      await addDoc(categoriesRef, {
        ...category,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });
      addedCount++;
    }

    return {
      success: true,
      message: `Successfully added ${addedCount} default categories`,
      count: addedCount
    };
  } catch (error) {
    console.error('Error seeding categories:', error);
    return {
      success: false,
      message: `Error: ${error.message}`,
      count: 0
    };
  }
};
